export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5861.3fd9cb15.jpg";